export default "__VITE_ASSET__Rm8R$iDP__"